<template>
  <form
    class="c-locations-search__form js-locations-form"
    id="locSearchboxForm"
    data-ajax="false"
    novalidate="novalidate"
    @submit.prevent="$emit('searchByAddress', searchAddress)"
    autocomplete="off"
  >
    <div class="c-locations-search__controls">
      <span tabindex="0" onclick="geoFindMe()" role="button" class="c-locations-search__icon-button c-locations-search__icon-button--geo">
        <img :src="`${assetPath}images/icons/map-icon.svg`" alt="Use My Location" style="height: 34px" />
      </span>
      <div class="c-locations-search__input">
        <input
          class="c-locations-search__input-field t-body--bold t-color--brown"
          type="text"
          id="address"
          name="address"
          v-model="searchAddress"
          placeholder="search by city, state, or zip"
        />
      </div>

      <img class="search-icon" :src="`${assetPath}images/icons/search-icon.svg`" alt="Submit" @click="$emit('searchByAddress', searchAddress)" />
    </div>
    <!-- <ul class="search-suggestions" v-if="showSuggestions">
      <li v-for="(suggestion, index) in suggestions" :key="index">
        <a @click="autoSuggestSearch([suggestion.position.lat, suggestion.position.lng])">{{ suggestion.address.label }}</a>
      </li>
    </ul> -->
  </form>
</template>
<script>
import { store } from '@/store';
export default {
  props: ['searchPerformed', 'performingSearch', 'query'],
  data() {
    return {
      assetPath: store.assetPath(),
      searchAddress: '',
      suggestions: [],
      userPos: null,
      showSuggestions: false,
    };
  },
  mounted() {
    if (this.query) {
      this.searchAddress = this.query;
      this.$emit('searchByAddress', this.query);
    }
    if (!this.userPos) {
      this.$http.get('/api/locations.php?lookup=ip').then(res => (this.userPos = res.data));
    }
  },
  methods: {
    async autoSuggest(event) {
      if (event.target.value != '' && event.target.value.split('').length >= 3) {
        var self = this;
        //If user doesn't supply position, try to get it from the server.

        //https://hooters.com/api/search_locations.json?address=${location}
        // const searchString = `https://geocoder.api.here.com/6.2/geocode.json?app_id=mFcz0JdMabmyM0WDE1G5&app_code=NYX4xhoHKkgBiCPT-A7evw&searchtext=`;
        const searchString = `https://autosuggest.search.hereapi.com/v1/autosuggest?apiKey=8cwTw-lFsBZqS5eaSGlsRv6xkuofp9TdvnHtPKNkTRk&at=${this.userPos}&q=`;

        this.$http.get(searchString + event.target.value).then(res => (self.suggestions = res.data.items));
        if (self.suggestions.length > 0) {
          this.showSuggestions = true;
        } else {
          this.showSuggestions = false;
        }
      } else {
        this.showSuggestions = false;
      }
    },
    autoSuggestSearch(address) {
      this.showSuggestions = false;
      this.$emit('searchByAddress', address);
    },
  },
};
</script>